import React from "react";
import PropTypes from "prop-types";

// Navigation
// ─────────────────────────────────────────────────────────────────────────────

export const ArrowLeftIcon = ({ size = 15 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M19 12H5M11 6l-6 6 6 6" />
  </svg>
);

export const ArrowRightIcon = ({ size = 15 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <line x1="5" y1="12" x2="19" y2="12" />
    <polyline points="12 5 19 12 12 19" />
  </svg>
);

export const ChevronDownIcon = ({ size = 14, expanded = false }) => (
  <svg width={size} height={size} viewBox="0 0 14 14" fill="none">
    <path
      d="M3 5l4 4 4-4"
      stroke={expanded ? "#0078d4" : "#475569"}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ChevronDownSmallIcon = ({ size = 12 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <polyline
      points="6,9 12,15 18,9"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const HomeIcon = ({ size = 17 }) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    width={size}
    height={size}
    stroke="currentColor"
    strokeWidth="2.2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
    <polyline points="9 22 9 12 15 12 15 22" />
  </svg>
);

// Actions
// ─────────────────────────────────────────────────────────────────────────────

export const DownloadIcon = ({ size = 17 }) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    width={size}
    height={size}
    stroke="currentColor"
    strokeWidth="2.2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
    <polyline points="7 10 12 15 17 10" />
    <line x1="12" y1="15" x2="12" y2="3" />
  </svg>
);

export const UploadArrowIcon = ({ size = 17 }) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    width={size}
    height={size}
    stroke="currentColor"
    strokeWidth="2.2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
    <polyline points="17 8 12 3 7 8" />
    <line x1="12" y1="3" x2="12" y2="15" />
  </svg>
);

export const CloudUploadIcon = ({ size = 24, color = "currentColor", strokeWidth = 1.6 }) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    width={size}
    height={size}
    stroke={color}
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M12 12v9" />
    <path d="M8.5 15.5L12 12l3.5 3.5" />
    <path d="M20.39 18.39A5 5 0 0 0 18 9h-1.26a8 8 0 1 0-14.74 4.3" />
  </svg>
);

export const RetryIcon = ({ size = 15 }) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    width={size}
    height={size}
    stroke="currentColor"
    strokeWidth="2.2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <polyline points="1 4 1 10 7 10" />
    <path d="M3.51 15a9 9 0 1 0 .49-3" />
  </svg>
);

export const CancelIcon = ({ size = 16 }) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    width={size}
    height={size}
    stroke="currentColor"
    strokeWidth="2.2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="12" cy="12" r="10" />
    <line x1="15" y1="9" x2="9" y2="15" />
    <line x1="9" y1="9" x2="15" y2="15" />
  </svg>
);

export const CloseIcon = ({ size = 14 }) => (
  <svg viewBox="0 0 14 14" fill="none" width={size} height={size}>
    <path d="M1 1l12 12M13 1L1 13" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
  </svg>
);

export const SearchIcon = ({ size = 14, className = "" }) => (
  <svg viewBox="0 0 16 16" fill="none" width={size} height={size} className={className}>
    <circle cx="6.5" cy="6.5" r="5" stroke="currentColor" strokeWidth="1.5" />
    <path d="M10.5 10.5l3.5 3.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
  </svg>
);

export const PlayIcon = ({ size = 13 }) => (
  <svg width={size} height={size} viewBox="0 0 11 13" fill="none" style={{ flexShrink: 0 }}>
    <path d="M1 1.5l9 5-9 5V1.5z" fill="currentColor" />
  </svg>
);

export const PlayCircleIcon = ({ size = 13 }) => (
  <svg viewBox="0 0 16 16" fill="none" width={size} height={size}>
    <circle cx="8" cy="8" r="7" stroke="currentColor" strokeWidth="1.4" />
    <path d="M6.5 5.5l5 2.5-5 2.5V5.5z" fill="currentColor" />
  </svg>
);

export const PlusIcon = ({ size = 17 }) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    width={size}
    height={size}
    stroke="currentColor"
    strokeWidth="2.3"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <line x1="12" y1="5" x2="12" y2="19" />
    <line x1="5" y1="12" x2="19" y2="12" />
  </svg>
);

export const SyncIcon = ({ size = 17 }) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    width={size}
    height={size}
    stroke="currentColor"
    strokeWidth="2.2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <polyline points="23 4 23 10 17 10" />
    <polyline points="1 20 1 14 7 14" />
    <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15" />
  </svg>
);

export const SyncAnimatedIcon = ({ size = 28 }) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    width={size}
    height={size}
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <polyline points="23 4 23 10 17 10" />
    <polyline points="1 20 1 14 7 14" />
    <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15" />
  </svg>
);

export const ShieldIcon = ({ size = 14 }) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    width={size}
    height={size}
    stroke="currentColor"
    strokeWidth="1.6"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M8 1.5l5.5 2v4c0 2.8-2.2 5.1-5.5 6C2.7 12.6.5 10.3.5 7.5v-4L8 1.5z" />
  </svg>
);

export const RefreshIcon = ({ size = 15, spinning = false }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    style={spinning ? { animation: "jd-spin 0.7s linear infinite" } : {}}
  >
    <path
      d="M23 4v6h-6"
      stroke="currentColor"
      strokeWidth="2.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"
      stroke="currentColor"
      strokeWidth="2.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const FunnelIcon = ({ size = 14 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <polygon
      points="22,3 2,3 10,12.46 10,19 14,21 14,12.46"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// Status indicators
// ─────────────────────────────────────────────────────────────────────────────

export const CheckIcon = ({ size = 11 }) => (
  <svg width={size} height={size} viewBox="0 0 12 12" fill="none" aria-hidden="true">
    <path
      d="M2 6l3 3 5-5"
      stroke="#fff"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CheckCircleFilledIcon = ({ size = 17 }) => (
  <svg viewBox="0 0 20 20" fill="none" width={size} height={size}>
    <circle cx="10" cy="10" r="9" fill="#16a34a" />
    <path
      d="M5.5 10l3 3 5-5.5"
      stroke="#fff"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CheckCircleOutlineIcon = ({ size = 28 }) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    width={size}
    height={size}
    stroke="currentColor"
    strokeWidth="2.2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <polyline points="20 6 9 17 4 12" />
  </svg>
);

export const ErrorCircleFilledIcon = ({ size = 16 }) => (
  <svg viewBox="0 0 20 20" fill="none" width={size} height={size}>
    <circle cx="10" cy="10" r="9" fill="#ef4444" />
    <path d="M10 5.5v5M10 13v.5" stroke="#fff" strokeWidth="1.7" strokeLinecap="round" />
  </svg>
);

export const FailCircleFilledIcon = ({ size = 16 }) => (
  <svg viewBox="0 0 16 16" fill="none" width={size} height={size}>
    <circle cx="8" cy="8" r="7.5" fill="#ef4444" />
    <path d="M5 5l6 6M11 5l-6 6" stroke="#fff" strokeWidth="1.6" strokeLinecap="round" />
  </svg>
);

export const AlertCircleIcon = ({ size = 28, color = "currentColor" }) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    width={size}
    height={size}
    stroke={color}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="12" cy="12" r="10" />
    <line x1="12" y1="8" x2="12" y2="12" />
    <line x1="12" y1="16" x2="12.01" y2="16" />
  </svg>
);

export const InfoIcon = ({ size = 15 }) => (
  <svg viewBox="0 0 20 20" fill="currentColor" width={size} height={size}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18 10A8 8 0 1 1 2 10a8 8 0 0 1 16 0zm-7-4a1 1 0 1 1-2 0
         1 1 0 0 1 2 0zm-1 9a1 1 0 0 1-1-1V9a1 1 0 1 1 2 0v5a1 1
         0 0 1-1 1z"
    />
  </svg>
);

export const ClockIcon = ({ size = 16 }) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    width={size}
    height={size}
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={{ flexShrink: 0, marginTop: 1 }}
  >
    <circle cx="12" cy="12" r="10" />
    <polyline points="12 6 12 12 16 14" />
  </svg>
);

export const PendingCircleIcon = ({ size = 16 }) => (
  <svg viewBox="0 0 16 16" fill="none" width={size} height={size}>
    <circle cx="8" cy="8" r="7" stroke="#cbd5e1" strokeWidth="1.5" />
  </svg>
);

// Job status row — small fixed-size icons (18 × 18)
// ─────────────────────────────────────────────────────────────────────────────

export const GreenCheckCircleSmallIcon = ({ className = "" }) => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" className={className}>
    <circle cx="9" cy="9" r="8.5" stroke="#16a34a" strokeWidth="1.2" fill="#f0fdf4" />
    <path
      d="M5.5 9.2l2.5 2.5 4.5-5"
      stroke="#16a34a"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const RedCrossCircleSmallIcon = ({ className = "" }) => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" className={className}>
    <circle cx="9" cy="9" r="8.5" stroke="#dc2626" strokeWidth="1.2" fill="#fef2f2" />
    <path
      d="M6.2 6.2l5.6 5.6M11.8 6.2l-5.6 5.6"
      stroke="#dc2626"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

export const GreyPauseCircleSmallIcon = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
    <circle cx="9" cy="9" r="8.5" stroke="#94a3b8" strokeWidth="1.2" fill="#f1f5f9" />
    <rect x="6.2" y="6" width="1.8" height="6" rx="0.6" fill="#94a3b8" />
    <rect x="10" y="6" width="1.8" height="6" rx="0.6" fill="#94a3b8" />
  </svg>
);

export const AmberSpinnerCircleSmallIcon = ({ className = "" }) => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" className={className}>
    <circle cx="9" cy="9" r="7.5" stroke="#e5e7eb" strokeWidth="2" fill="none" />
    <path d="M9 1.5A7.5 7.5 0 0 1 16.5 9" stroke="#f59e0b" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

// File-type icons
// ─────────────────────────────────────────────────────────────────────────────

export const GenericFileIcon = ({ size = 20 }) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    width={size}
    height={size}
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
    <polyline points="14 2 14 8 20 8" />
  </svg>
);

export const DropZoneFileIcon = ({ size = 18 }) => (
  <svg
    viewBox="0 0 20 20"
    fill="none"
    width={size}
    height={size}
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M11 2H5a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7z" />
    <polyline points="11 2 11 7 16 7" />
  </svg>
);

export const VideoFileIcon = ({ size = 20 }) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    width={size}
    height={size}
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="2" y="4" width="20" height="16" rx="2" />
    <path d="M10 9l5 3-5 3V9z" fill="currentColor" stroke="none" />
  </svg>
);

export const VideoFileSmallIcon = ({ size = 16 }) => (
  <svg
    viewBox="0 0 20 20"
    fill="none"
    width={size}
    height={size}
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="1" y="3" width="18" height="14" rx="2.5" />
    <path d="M7.5 7l5.5 3-5.5 3V7z" fill="currentColor" stroke="none" />
  </svg>
);

export const SubtitleFileIcon = ({ size = 20 }) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    width={size}
    height={size}
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="2" y="4" width="20" height="16" rx="2" />
    <line x1="6" y1="10" x2="18" y2="10" />
    <line x1="6" y1="14" x2="14" y2="14" />
  </svg>
);

export const SrtFileIcon = ({ size = 16 }) => (
  <svg
    viewBox="0 0 20 20"
    fill="none"
    width={size}
    height={size}
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="1" y="3" width="18" height="14" rx="2.5" />
    <line x1="4" y1="9" x2="16" y2="9" />
    <line x1="4" y1="13" x2="11" y2="13" />
  </svg>
);

export const ZipFileIcon = ({ size = 20 }) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    width={size}
    height={size}
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
    <polyline points="14 2 14 8 20 8" />
    <line x1="12" y1="12" x2="12" y2="18" />
    <line x1="9" y1="15" x2="15" y2="15" />
  </svg>
);

// Dashboard stat-card icons
// ─────────────────────────────────────────────────────────────────────────────

export const TotalJobsIcon = ({ size = 22 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <path
      d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <polyline
      points="14,2 14,8 20,8"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <line
      x1="16"
      y1="13"
      x2="8"
      y2="13"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <line
      x1="16"
      y1="17"
      x2="8"
      y2="17"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export const CompletedJobsIcon = ({ size = 22 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" />
    <polyline
      points="9,12 11,14 15,10"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ProcessingJobsIcon = ({ size = 22 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" />
    <polyline
      points="12,6 12,12 16,14"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const DownloadJobsIcon = ({ size = 22 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <path
      d="M12 2v13M7 10l5 5 5-5"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const FailedJobsIcon = ({ size = 22 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" />
    <line
      x1="12"
      y1="8"
      x2="12"
      y2="12"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <circle cx="12" cy="16" r="1" fill="currentColor" />
  </svg>
);

// Service Selection
// ─────────────────────────────────────────────────────────────────────────────

export const BriefcaseIcon = ({ size = 18 }) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    width={size}
    height={size}
  >
    <rect x="2" y="7" width="20" height="14" rx="2" ry="2" />
    <path d="M16 7V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2" />
    <line x1="8" y1="12" x2="16" y2="12" />
  </svg>
);

export const LeafIcon = ({ size = 18 }) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    width={size}
    height={size}
  >
    <path
      d="M11 20A7 7 0 0 1 9.8 6.1C15.5 5 17 4.48 19 2c1 2 2 4.18 2 8
             0 5.5-4.78 10-10 10z"
    />
    <path d="M2 21c0-3 1.85-5.36 5.08-6C9.5 14.52 12 13 13 12" />
  </svg>
);

export const GearIcon = ({ size = 18 }) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    width={size}
    height={size}
  >
    <circle cx="12" cy="12" r="3" />
    <path
      d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06
      a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09
      A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83
      l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09
      A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83
      l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09
      a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83
      l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09
      a1.65 1.65 0 0 0-1.51 1z"
    />
  </svg>
);

// Auth / Brand
// ─────────────────────────────────────────────────────────────────────────────

export const AppLogoIcon = ({ size = 48 }) => (
  <svg viewBox="0 0 48 48" fill="none" width={size} height={size}>
    <rect width="48" height="48" rx="12" fill="#0078d4" />
    <path d="M14 24 L24 14 L34 24 L24 34 Z" fill="white" opacity="0.9" />
    <circle cx="24" cy="24" r="4" fill="white" />
  </svg>
);

export const LockIcon = ({ className = "" }) => (
  <svg className={className} viewBox="0 0 64 64" fill="none" aria-hidden="true">
    <rect
      x="10"
      y="28"
      width="44"
      height="30"
      rx="6"
      fill="#e0eaf6"
      stroke="#0078d4"
      strokeWidth="2.5"
    />
    <path
      d="M20 28V20a12 12 0 1 1 24 0v8"
      stroke="#0078d4"
      strokeWidth="2.5"
      strokeLinecap="round"
    />
    <circle cx="32" cy="43" r="4" fill="#0078d4" />
    <line
      x1="32"
      y1="47"
      x2="32"
      y2="52"
      stroke="#0078d4"
      strokeWidth="2.5"
      strokeLinecap="round"
    />
  </svg>
);

export const MicIcon = ({ size = 18 }) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    width={size}
    height={size}
  >
    <path d="M12 2a3 3 0 0 1 3 3v7a3 3 0 0 1-6 0V5a3 3 0 0 1 3-3z" />
    <path d="M19 10v2a7 7 0 0 1-14 0v-2" />
    <line x1="12" y1="19" x2="12" y2="23" />
    <line x1="8" y1="23" x2="16" y2="23" />
  </svg>
);

export const MicHeroIcon = ({ className = "" }) => (
  <svg className={className} viewBox="0 0 64 64" fill="none" aria-hidden="true">
    <rect
      x="22"
      y="4"
      width="20"
      height="32"
      rx="10"
      fill="#e0eaf6"
      stroke="#0078d4"
      strokeWidth="2.5"
    />
    <path
      d="M14 30c0 9.941 8.059 18 18 18s18-8.059 18-18"
      stroke="#0078d4"
      strokeWidth="2.5"
      strokeLinecap="round"
    />
    <line
      x1="32"
      y1="48"
      x2="32"
      y2="58"
      stroke="#0078d4"
      strokeWidth="2.5"
      strokeLinecap="round"
    />
    <line
      x1="24"
      y1="58"
      x2="40"
      y2="58"
      stroke="#0078d4"
      strokeWidth="2.5"
      strokeLinecap="round"
    />
  </svg>
);

export const SadFaceIcon = ({ size = 56 }) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    width={size}
    height={size}
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="12" cy="12" r="10" />
    <path d="M16 16s-1.5-2-4-2-4 2-4 2" />
    <line x1="9" y1="9" x2="9.01" y2="9" />
    <line x1="15" y1="9" x2="15.01" y2="9" />
  </svg>
);

// Voice Settings Modal
// ─────────────────────────────────────────────────────────────────────────────

export const SelectedCheckIcon = ({ size = 14 }) => (
  <svg viewBox="0 0 14 14" fill="none" width={size} height={size}>
    <circle cx="7" cy="7" r="7" fill="#1d4ed8" />
    <path
      d="M3.5 7l2.5 2.5 4.5-4.5"
      stroke="#fff"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SoundWaveAnimatedIcon = ({ size = 13 }) => (
  <svg viewBox="0 0 16 16" fill="none" width={size} height={size}>
    <rect x="1" y="5" width="2" height="6" rx="1" fill="currentColor">
      <animate attributeName="height" values="6;10;6" dur="0.8s" repeatCount="indefinite" />
      <animate attributeName="y" values="5;3;5" dur="0.8s" repeatCount="indefinite" />
    </rect>
    <rect x="5" y="3" width="2" height="10" rx="1" fill="currentColor">
      <animate
        attributeName="height"
        values="10;4;10"
        dur="0.8s"
        begin="0.2s"
        repeatCount="indefinite"
      />
      <animate attributeName="y" values="3;6;3" dur="0.8s" begin="0.2s" repeatCount="indefinite" />
    </rect>
    <rect x="9" y="4" width="2" height="8" rx="1" fill="currentColor">
      <animate
        attributeName="height"
        values="8;12;8"
        dur="0.8s"
        begin="0.1s"
        repeatCount="indefinite"
      />
      <animate attributeName="y" values="4;2;4" dur="0.8s" begin="0.1s" repeatCount="indefinite" />
    </rect>
    <rect x="13" y="6" width="2" height="5" rx="1" fill="currentColor">
      <animate
        attributeName="height"
        values="5;9;5"
        dur="0.8s"
        begin="0.3s"
        repeatCount="indefinite"
      />
      <animate attributeName="y" values="6;4;6" dur="0.8s" begin="0.3s" repeatCount="indefinite" />
    </rect>
  </svg>
);

export const SpinnerCircleIcon = ({ size = 28, className = "" }) => (
  <svg viewBox="0 0 24 24" fill="none" width={size} height={size} className={className}>
    <circle cx="12" cy="12" r="10" stroke="#e2e8f0" strokeWidth="3" />
    <path d="M12 2a10 10 0 0 1 10 10" stroke="#1d4ed8" strokeWidth="3" strokeLinecap="round" />
  </svg>
);

export const EmptyStateIcon = ({ size = 40 }) => (
  <svg viewBox="0 0 48 48" fill="none" width={size} height={size}>
    <circle cx="24" cy="24" r="22" stroke="#cbd5e1" strokeWidth="2" />
    <path d="M16 24h16M24 16v16" stroke="#cbd5e1" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

export const SaveCheckIcon = ({ size = 14 }) => (
  <svg viewBox="0 0 16 16" fill="none" width={size} height={size}>
    <path
      d="M13.5 4.5l-7 7L3 8"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SmallCheckCirclePillIcon = ({ size = 10 }) => (
  <svg viewBox="0 0 10 10" fill="none" width={size} height={size}>
    <circle cx="5" cy="5" r="5" fill="#16a34a" />
    <path
      d="M2.5 5l1.8 1.8 3.2-3.2"
      stroke="#fff"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// Misc / Inline shapes
// ─────────────────────────────────────────────────────────────────────────────

export const WarnTriangleIcon = ({ size = 14 }) => (
  <svg
    viewBox="0 0 20 20"
    fill="currentColor"
    width={size}
    height={size}
    style={{ flexShrink: 0, marginTop: 1 }}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75
         1.334-.213 3.001-1.742 3.001H4.42c-1.53 0-2.493-1.667-1.743
         -3.001l5.58-9.92zM11 13a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm-1-5a1
         1 0 0 0-1 1v2a1 1 0 1 0 2 0V9a1 1 0 0 0-1-1z"
    />
  </svg>
);

export const SmallErrorCircleIcon = ({ size = 12 }) => (
  <svg viewBox="0 0 14 14" fill="none" width={size} height={size}>
    <circle cx="7" cy="7" r="6" fill="#ef4444" />
    <path d="M7 4v3M7 9.5v.5" stroke="#fff" strokeWidth="1.4" strokeLinecap="round" />
  </svg>
);

export const ServiceSelectedCheckIcon = ({ size = 12 }) => (
  <svg viewBox="0 0 20 20" fill="none" width={size} height={size}>
    <path
      d="M4 10l4 4 8-8"
      stroke="#fff"
      strokeWidth="2.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ErrorBoundaryIcon = ({ size = 48 }) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    width={size}
    height={size}
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="12" cy="12" r="10" />
    <line x1="12" y1="8" x2="12" y2="12" />
    <line x1="12" y1="16" x2="12.01" y2="16" />
  </svg>
);

ArrowLeftIcon.propTypes = { size: PropTypes.number };
ArrowRightIcon.propTypes = { size: PropTypes.number };
ChevronDownIcon.propTypes = {
  size: PropTypes.number,
  expanded: PropTypes.bool,
};
ChevronDownSmallIcon.propTypes = { size: PropTypes.number };
HomeIcon.propTypes = { size: PropTypes.number };
DownloadIcon.propTypes = { size: PropTypes.number };
UploadArrowIcon.propTypes = { size: PropTypes.number };
CloudUploadIcon.propTypes = {
  size: PropTypes.number,
  color: PropTypes.string,
  strokeWidth: PropTypes.number,
};
RetryIcon.propTypes = { size: PropTypes.number };
CancelIcon.propTypes = { size: PropTypes.number };
CloseIcon.propTypes = { size: PropTypes.number };
SearchIcon.propTypes = { size: PropTypes.number, className: PropTypes.string };
PlayIcon.propTypes = { size: PropTypes.number };
PlayCircleIcon.propTypes = { size: PropTypes.number };
PlusIcon.propTypes = { size: PropTypes.number };
SyncIcon.propTypes = { size: PropTypes.number };
SyncAnimatedIcon.propTypes = { size: PropTypes.number };
ShieldIcon.propTypes = { size: PropTypes.number };
RefreshIcon.propTypes = { size: PropTypes.number, spinning: PropTypes.bool };
FunnelIcon.propTypes = { size: PropTypes.number };
CheckIcon.propTypes = { size: PropTypes.number };
CheckCircleFilledIcon.propTypes = { size: PropTypes.number };
CheckCircleOutlineIcon.propTypes = { size: PropTypes.number };
ErrorCircleFilledIcon.propTypes = { size: PropTypes.number };
FailCircleFilledIcon.propTypes = { size: PropTypes.number };
AlertCircleIcon.propTypes = { size: PropTypes.number, color: PropTypes.string };
InfoIcon.propTypes = { size: PropTypes.number };
ClockIcon.propTypes = { size: PropTypes.number };
PendingCircleIcon.propTypes = { size: PropTypes.number };
GreenCheckCircleSmallIcon.propTypes = { className: PropTypes.string };
RedCrossCircleSmallIcon.propTypes = { className: PropTypes.string };
AmberSpinnerCircleSmallIcon.propTypes = { className: PropTypes.string };
GenericFileIcon.propTypes = { size: PropTypes.number };
DropZoneFileIcon.propTypes = { size: PropTypes.number };
VideoFileIcon.propTypes = { size: PropTypes.number };
VideoFileSmallIcon.propTypes = { size: PropTypes.number };
SubtitleFileIcon.propTypes = { size: PropTypes.number };
SrtFileIcon.propTypes = { size: PropTypes.number };
ZipFileIcon.propTypes = { size: PropTypes.number };
TotalJobsIcon.propTypes = { size: PropTypes.number };
CompletedJobsIcon.propTypes = { size: PropTypes.number };
ProcessingJobsIcon.propTypes = { size: PropTypes.number };
DownloadJobsIcon.propTypes = { size: PropTypes.number };
FailedJobsIcon.propTypes = { size: PropTypes.number };
BriefcaseIcon.propTypes = { size: PropTypes.number };
LeafIcon.propTypes = { size: PropTypes.number };
GearIcon.propTypes = { size: PropTypes.number };
AppLogoIcon.propTypes = { size: PropTypes.number };
LockIcon.propTypes = { className: PropTypes.string };
MicIcon.propTypes = { size: PropTypes.number };
MicHeroIcon.propTypes = { className: PropTypes.string };
SadFaceIcon.propTypes = { size: PropTypes.number };
SelectedCheckIcon.propTypes = { size: PropTypes.number };
SoundWaveAnimatedIcon.propTypes = { size: PropTypes.number };
SpinnerCircleIcon.propTypes = {
  size: PropTypes.number,
  className: PropTypes.string,
};
EmptyStateIcon.propTypes = { size: PropTypes.number };
SaveCheckIcon.propTypes = { size: PropTypes.number };
SmallCheckCirclePillIcon.propTypes = { size: PropTypes.number };
WarnTriangleIcon.propTypes = { size: PropTypes.number };
SmallErrorCircleIcon.propTypes = { size: PropTypes.number };
ServiceSelectedCheckIcon.propTypes = { size: PropTypes.number };
ErrorBoundaryIcon.propTypes = { size: PropTypes.number };

export const LoginAlertIcon = ({ size = 40 }) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    width={size}
    height={size}
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="12" cy="12" r="10" />
    <line x1="12" y1="8" x2="12" y2="12" />
    <line x1="12" y1="16" x2="12.01" y2="16" />
  </svg>
);

LoginAlertIcon.propTypes = { size: PropTypes.number };
